// extracted by mini-css-extract-plugin
export var accordion = "_ex-0";
export var chevron = "_ex-3";
export var closed = "_ex-2";
export var content = "_ex-4";
export var open = "_ex-1";
export var rotate = "_ex-5";